import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const AdvertLibrary = () => {
  const { groupId } = useParams();

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Advert Library
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Advert library for Group ID: {groupId}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default AdvertLibrary;